/**
 * 사진 업로드 공통 베이스
 *
 * [스텝 구조]
 * ① 사진 업로드 (촬영/갤러리/드래그앤드롭) + 썸네일 그리드 + 삭제
 *
 * DiaryJobs, DiaryDocs 가 상속하여 사용
 */
import Util from '../../Common/Util';

export default class DiaryPhotoBase {
    constructor() {
        this.pool = [];        // [{photoNum, id, host, path, thumbUrl, assignedTo}]
    }

    // ─── 설정 (서브클래스에서 override) ──────────────
    get pfx()           { return ''; }      // ID 접두어: 'dj' | 'dd'
    get uploadTag()     { return ''; }      // 'docs'
    get uploadContext()  { return ''; }      // 'diaryJobs' | 'diaryDocs'
    get maxSheet()      { return 5; }
    get pointBadgeHtml() { return ''; }
    get descHtml() { return ''; }
    get hasAssignment() { return false; }
    get uploadBtnsHtml() {
        return `
                <div class="mc-upload-btns">
                    <button class="mc-up-btn mc-pool-upload-btn" data-from="C">📷 촬영</button>
                    <button class="mc-up-btn mc-pool-upload-btn" data-from="G">🖼 갤러리</button>
                </div>`;
    }

    // ─── API (서브클래스에서 override) ───────────────
    _loadUrl(ordernum)            { return ''; }
    _addUrl(ordernum)             { return ''; }
    _addParams(file)              { return { img_id: file.id }; }
    _deleteRequest(ordernum, pn)  { }
    _parseList(list)              { return []; }

    // ─── 공통 ───────────────────────────────────────
    get isPC() { return !/Android|iPhone|iPad|iPod/i.test(navigator.userAgent); }

    destroy() {
        // 닫힘 표시 — 두 탭(작업문서·현장사진)은 허브의 같은 자리(contentDivId)에 번갈아 그려진다. 닫힌 탭이 보낸 목록 요청이
        // 늦게 오면 지금 열린 탭 화면에 그려졌다(2026-10-26). 응답 처리는 이 표시를 보고 버린다.
        this._dead = true;
        $j.Ui.Div.destroyByContainer(this);   // 인라인으로 띄운 DevicePicker 도 함께 정리
        $(`#${this.id}`).off();
        $j.Common.EventBus.offNamespace($j.getNS(this));
    }

    init() { this.loadExisting(); }

    loadExisting() {
        const self = this;
        const ordernum = this._ordernum();
        $.ajax({
            type: 'GET', url: this._loadUrl(ordernum),
            success(r) { if (self._dead) return; if (r.result && r.list) self.pool = self._parseList(r.list); },
            complete() { if (self._dead) return; self.draw(); self.initHandler(); }
        });
    }

    /**
     * 목록만 다시 읽어 그리드 갱신 (draw/initHandler 재실행 없음 — 위임 핸들러 중복 바인딩 방지).
     * BS 가 다른 target 으로 교체돼 DOM 이 사라진 상태면 아무 것도 하지 않는다.
     */
    reloadPool() {
        const self = this;
        if (!$(`#${this.id}`).length) return;
        $.ajax({
            type: 'GET', url: this._loadUrl(this._ordernum()),
            success(r) {
                if (self._dead) return;   // 탭이 바뀐 뒤 도착한 응답 — 같은 자리에 다른 탭이 그려져 있다
                if (!r.result || !r.list) return;
                self.pool = self._parseList(r.list);
                self.refresh();
            },
        });
    }

    // ─── 렌더링 ─────────────────────────────────────
    draw() {
        const p = this.pfx;
        const html = `
        <div class="mc-pane" style="padding:0 0 24px;">
            <!-- ① 사진 업로드 -->
            <div class="mc-step-section">
                <div class="mc-step-header">
                    <div class="mc-step-badge">1</div>
                    <span class="mc-step-label">사진 업로드</span>
                    ${this.pointBadgeHtml}
                </div>
                ${this.descHtml}
                ${this.uploadBtnsHtml}
                ${this.isPC ? '<div class="mc-dropzone">이미지를 여기에 드래그앤드롭</div>' : ''}
            </div>

            <div id="${p}-grid-wrap" style="display:none;margin-bottom:12px;">
                <div class="mc-assign-grid" id="${p}-grid"></div>
            </div>
            ${this._extraHtml()}
        </div>`;

        $(`#${this.id}`).html(html);
        this.refresh();
    }

    /** 서브클래스 확장 포인트 (배정 섹션 등) */
    _extraHtml() { return ''; }

    /**
     * 파일 선택 진입점 — 기본은 앱 네이티브 피커(촬영/갤러리).
     * 서브클래스가 override 해서 다른 피커(예: 디바이스 사진 그리드)를 열 수 있다.
     * @param {string|undefined} from 'C'(카메라) | 'G'(갤러리) | undefined(앱이 선택 시트 표시)
     */
    pickFiles(from) {
        $j.F.Upload.addPhotoHere({
            tag: this.uploadTag,
            context: this.uploadContext,
            max_sheet: this.maxSheet,
            from: from,
            id: this._ordernum(),
        });
    }

    // ─── 이벤트 ─────────────────────────────────────
    initHandler() {
        const $el = $(`#${this.id}`);
        const self = this;

        // 업로드
        $el.on('click', '.mc-pool-upload-btn', function () {
            self.pickFiles($(this).data('from'));
        });

        $j.Common.EventBus.on($j.getNS(this), 'upload:image', (e, payload) => {
            if ($j.F.Upload.getContext() !== self.uploadContext) return;
            const ordernum = self._ordernum();
            (Array.isArray(payload) ? payload : [payload]).forEach(file => {
                $.post(self._addUrl(ordernum), self._addParams(file), (r) => {
                    if (r?.result) {
                        self.pool.push({
                            photoNum: r.photoNum, id: file.id, host: file.host, path: file.path,
                            thumbUrl: Util.getImageUrl(file.path, file.host, 'x100'), assignedTo: null,
                        });
                        self.refresh();
                    }
                });
            });
        });

        if (this.isPC) this._initDropzone();

        // 썸네일 클릭 → 확대 보기 (ZoomPhoto)
        $el.on('click', '.mc-grid-cell', function () {
            const idx = parseInt($(this).data('idx'));
            self.openViewer(idx);
        });

        // Gallery 삭제 이벤트 (Gallery 가 서버 삭제까지 처리하므로 풀에서만 제거)
        $j.Common.EventBus.on($j.getNS(this), 'gallery:delete', (e, payload) => {
            const { ordernum, img_id } = payload || {};
            if (String(ordernum) !== String(self._ordernum())) return;
            const idx = self.pool.findIndex(p => String(p.id) === String(img_id));
            if (idx === -1) return;
            self.pool.splice(idx, 1);
            self._onAfterDelete();
            self.refresh();
        });

        this._initExtraHandlers($el);
    }

    /** 풀의 사진을 일지 공통 Gallery 뷰어로 열기 */
    openViewer(idx) {
        const photo = this.pool[idx];
        if (!photo) return;
        $j.F.Order.Gallery.init(this._ordernum(), photo.id);
    }

    /** 서브클래스 확장 포인트 */
    _onAfterDelete() { }
    _initExtraHandlers($el) { }

    _initDropzone() {
        const $dz = $(`#${this.id}`).find('.mc-dropzone');
        if (!$dz.length) return;
        // BS 의 스크롤 컨테이너 (.content-area). 자체 BS 구현 전엔 .mbsc-popup-content 였음.
        const pc = $dz.closest('.bottomsheet-panel > .content-area, .content-area')[0];
        if (pc) { ['dragover','dragenter','drop'].forEach(ev => pc.addEventListener(ev, e => e.preventDefault())); }
        $dz[0].ondragenter = e => e.preventDefault();
        $dz[0].ondragover = e => { e.preventDefault(); $dz.css({ borderColor: '#FDCF43', background: '#FFFEF7' }); };
        $dz[0].ondragleave = () => $dz.css({ borderColor: '', background: '' });
        $dz[0].ondrop = e => {
            e.preventDefault(); $dz.css({ borderColor: '', background: '' });
            $j.F.Upload.options = { tag: this.uploadTag, context: this.uploadContext, id: this._ordernum() };
            Array.from(e.dataTransfer.files).forEach(f => { if (f.type.startsWith('image/')) $j.F.Upload.uploadFile(f); });
        };
    }

    // ─── UI 갱신 ────────────────────────────────────
    refresh() {
        const hasPhotos = this.pool.length > 0;
        const $el = $(`#${this.id}`);
        const p = this.pfx;

        // 그리드
        $el.find(`#${p}-grid-wrap`).css('display', hasPhotos ? '' : 'none');
        this.renderGrid();

        this._refreshExtra($el, hasPhotos);
    }

    /** 서브클래스 확장 포인트 */
    _refreshExtra($el, hasPhotos) { }

    renderGrid() {
        const $g = $(`#${this.id}`).find(`#${this.pfx}-grid`).empty();
        this.pool.forEach((p, idx) => {
            const thumb = p.thumbUrl || Util.getImageUrl(p.path, p.host, 'x100');
            $g.append(`
            <div class="mc-grid-cell" data-idx="${idx}" style="position:relative;border-radius:10px;overflow:hidden;aspect-ratio:1;cursor:pointer;border:1.5px dashed #DDDDDD;">
                <img src="${thumb}" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;">
            </div>`);
        });
    }

    _ordernum() { return this.data?.ordernum || (typeof ORDER !== 'undefined' ? ORDER['num'] : ''); }
}
